module.exports = __webpack_public_path__ + "img/plus.6800c998.svg";